// extracted by mini-css-extract-plugin
export var pPlan = "plan-module--p-plan--2sl-7";
export var lContent__inner = "plan-module--l-content__inner--3wDDu";
export var pPlan__list = "plan-module--p-plan__list--1Qcuv";
export var basic = "plan-module--basic--3Ouy1";
export var custom = "plan-module--custom--uAZQX";
export var pPlan__swipe = "plan-module--p-plan__swipe--27M5E";
export var pPlan__swipe__slide = "plan-module--p-plan__swipe__slide--g6K3N";
export var oNotice = "plan-module--o-notice--k9xIP";
export var visible = "plan-module--visible--1dIGa";
export var subcopyBefore = "plan-module--subcopy-before--3J8id";
export var subcopyAfter = "plan-module--subcopy-after--1DlmL";
export var price = "plan-module--price--3QP7X";
export var standby = "plan-module--standby--p-Z0H";
export var oPrice = "plan-module--o-price--1Lvn4";
export var oPrice__title = "plan-module--o-price__title--PYxeP";
export var oPrice__tagline = "plan-module--o-price__tagline--26B4H";
export var oPrice__delivery = "plan-module--o-price__delivery--138Bt";
export var oPrice__price = "plan-module--o-price__price--yzKeO";
export var oPrice__output = "plan-module--o-price__output--jnRSe";
export var extra = "plan-module--extra--a9Kmr";
export var oPrice__output__simple = "plan-module--o-price__output__simple--2tFsx";
export var oPrice__recommend = "plan-module--o-price__recommend--2xm9O";